import { abilitiesPlugin } from '@casl/vue'
import { appAbility } from '~/authorization/ability'

export default defineNuxtPlugin((nuxt) => {
  nuxt.vueApp.use(abilitiesPlugin, appAbility(), { useGlobalProperties: true })
})
